import { Grid, Stack, Typography, CardContent, Link } from "@mui/material";
import "./login.scss";
import { StyledCard } from "../../components/ui/Cards";
import logoColor from "../../assets/logoColor.svg";

export default function DataDeletionRequest() {
  return (
    <div className="main">
      <Grid container alignItems="center" justifyContent="center">
        <StyledCard
          sx={{
            width: { xs: "90%", sm: "70%", md: "50%", lg: "40%" },
            maxWidth: "600px",
            my: 4,
          }}
        >
          <CardContent>
            <Stack spacing={2} className="formContainer">
              <Stack spacing={1} alignItems="center" textAlign="center">
                <img src={logoColor} alt="VePay Logo" className="logo" />
              </Stack>

              <Stack spacing={4} sx={{ mt: 6 }}>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                >
                  Account Deactivation Request
                </Typography>
                <Typography variant="body1" sx={{ textAlign: "center" }}>
                  To request the deactivation of your account and associated
                  data, please email{" "}
                  <Link
                    href="mailto:support@vepay.io"
                    sx={{ fontWeight: "bold" }}
                  >
                    support@vepay.io
                  </Link>{" "}
                  from the email address associated with your registered
                  account.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", color: "text.secondary" }}
                >
                  Upon request, we will deactivate your profile information,
                  transaction history, and saved preferences within 35 - 40
                  days. We retain financial logs for up to 5 years for legal
                  compliance.
                </Typography>
              </Stack>
            </Stack>
          </CardContent>
        </StyledCard>
      </Grid>
    </div>
  );
}
